import { TagType } from 'generated/graphql';

export type NoteTextType =  'text' | 'date' | 'number';
export function getNoteTypeFromTagType(inputType: string | TagType | any): NoteTextType {
  const lcType = inputType?.toLowerCase();
  if (lcType === 'date') {
    return 'date';
  }
  if (lcType === 'number') {
    return 'number';
  }

  return 'text';
}
